export default "__VITE_ASSET__DYSjVzUT__"